import React, { useEffect } from "react"
import { Container, Divider, Stack, Typography } from "@mui/material"
import { LegalDocument } from "@/features/legal/content/legalContent"

interface LegalDocumentPageProps {
  legalDocument: LegalDocument
}

const LegalDocumentPage: React.FC<LegalDocumentPageProps> = ({ legalDocument }) => {
  useEffect(() => {
    document.title = `${legalDocument.title} | ListYourProduct`
  }, [legalDocument.title])

  return (
    <Container component="main" maxWidth="md" sx={{ pt: { xs: 11, md: 13 }, pb: 8 }}>
      <Stack spacing={2.5}>
        <Typography variant="h4" fontWeight={700}>
          {legalDocument.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Effective Date: {legalDocument.effectiveDate}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {legalDocument.intro}
        </Typography>
        <Divider />
        {legalDocument.sections.map(section => (
          <Stack key={section.heading} spacing={1.25}>
            <Typography variant="h6" fontWeight={700}>
              {section.heading}
            </Typography>
            {section.paragraphs.map(paragraph => (
              <Typography key={paragraph} variant="body2" color="text.secondary">
                {paragraph}
              </Typography>
            ))}
          </Stack>
        ))}
      </Stack>
    </Container>
  )
}

export default LegalDocumentPage
